// myPOS Smart SDK TransactionProcessingResult values; TWINT_NOT_SUPPORTED is app-defined.
export enum MyPosTransactionCodeError {
  USER_CANCEL_PAYMENT = 1,
  TRANSACTION_DECLINED = 2,
  TRANSACTION_FAILED = 3,
  NO_DATA_FOUND = 5,
  INVALID_CURRENCY = 6,
  INVALID_AMOUNT = 7,
  COMMUNICATION_ERROR = 8,
  TWINT_NOT_SUPPORTED = 998,
}

export enum MyPosTransactionMessageError {
  'terminal_transaction_error_user_cancel' = 1,
  'terminal_transaction_error_declined' = 2,
  'terminal_transaction_error_failed' = 3,
  'terminal_transaction_error_no_data_found' = 5,
  'terminal_transaction_error_wrong_currency' = 6,
  'terminal_transaction_error_invalid_amount' = 7,
  'terminal_error_connect_fail' = 8,
  'terminal_transaction_error_twint_disabled' = 998,
}

export enum MyPosTransactionResponseCode {
  NOT_SUPPORTED = 'NOT_SUPPORTED',
  CANCELLED = 'CANCELLED',
}
